













































import { Vue, Prop, Component } from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';

@Component({
  components: {
    'label-slot': LabelSlot,
  },
})
export default class SearchCustomerComponent extends Vue {
  @Prop() labelOption!: string;

  @Prop() value!: string;

  @Prop() productItemText!: string;

  @Prop({ type: Boolean, default: false })
  showSelectAll!: boolean;

  @Prop({ type: Array, default: () => ([]) })
  products!: Array<String>;

  @Prop({ type: Boolean, default: false }) multiple! : boolean

  selectedAll: boolean = false;

  updateField(field: string, value) {
    this.$emit(`update:${field}`, value);
  }

  input(value: string) {
    this.$emit('input', value);
  }

  selectAll() {
    this.$emit('select-all', this.selectedAll);
  }
}
